import React from "react";
import "./InputBet.scss";

const InputBet = (props) => {
  return (
    <div className={`btn-group-row ${props.isSpined && "disabled"}`}>
      <div 
        className="btn btn-dark btn-min"
        onClick={() => props.click('min')}
      >Min</div>
      <div className="input-row">
        <div 
          className="btn btn-dark btn-mins"
          onClick={() => props.click('mins')}
        >-</div>
        <input 
          type="number" 
          step="0.1" 
          value={props.amount}
          onChange={(e) => props.change(e)}
        />
        <div 
          className="btn btn-dark btn-plus"
          onClick={() => props.click('plus')}
        >+</div>
      </div>
      <div 
        className="btn btn-dark btn-max" 
        onClick={() => props.click('max')}
      >Max</div>
    </div>
  )
}

export default InputBet;